import axios from '../../../../../utils/axios';
import store from '../../../../../store';
import { objectAssign } from '@isyscore/utils/object';

export const getBasicConfig = async (data) => {
    const params = {
        ...data,
        appName: 'isc-sys-config-service'
    };
    return await axios.get(`/api/ops/config/common/page/configGet`, { params });
};

export const updateBasicConfig = async (map) => {
    const params = {
        appName: 'isc-sys-config-service',
        map
    };
    await axios.post(`/api/ops/config/common/page/configUpdate`, params);
    store.state.desk.brandName = map.enterprise;
    store.state.desk.brandLogo = map.logo;
    await store.dispatch('desk/getBrandConfig');
};

export async function queryCanEdit(ids) {
    return axios.post('/api/core/license/desc/additional', { ids: ids });
}
